import { render, staticRenderFns } from "./tabSponsorAdvertisements.vue?vue&type=template&id=29917d30&"
import script from "./tabSponsorAdvertisements.vue?vue&type=script&lang=js&"
export * from "./tabSponsorAdvertisements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports